export class Plato {
    private id: number;
    private descripcion: string;
    private platoDia: boolean;
    private habilitado: boolean;

    constructor( descripcion: string, platoDelDia: boolean, habilitado: boolean = true, id: number = null ) {
        this.descripcion = descripcion;
        this.platoDia = platoDelDia;
        this.habilitado = habilitado;
        this.id = id;
    }
    public getId(): number {
        return this.id;
    }
    public setId(value: number) {
        this.id = value;
    }
    public getHabilitado(): boolean {
        return this.habilitado;
    }
    public setHabilitado(value: boolean) {
        this.habilitado = value;
    }
    public getDescripcion(): string {
        return this.descripcion;
    }
    public setDescripcion(value: string) {
        this.descripcion = value;
    }
    public getPlatoDelDia(): boolean {
        return this.platoDia;
    }
    public setPlatoDelDia(value: boolean) {
        this.platoDia = value;
    }
}